export default __webpack_public_path__ + "static/media/Piggy.e5f7caaa.svg";